export default __webpack_public_path__ + "static/media/LEAK TESTING MACHINE.2889fc27.png";